import React from "react"
import styled from "styled-components"
import { Container, Grid, FadeIn} from "../components/DesignSystem"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"

export const StyledProjectContent = styled.main`
  padding: 6rem 0;
  overflow: hidden;
  background: ${props => props.background ? props.background : "#F8F9FA"};
  h2, h3, h4, p, ul, ol, blockquote {
    max-width: var(--contentMaxWidth);;
    margin-left: auto;
    margin-right: auto;
  }
  h2 {
    font-size: var(--fontSizeXL);
    margin-top: 5rem;
  }
  h3 {
    font-size: var(--fontSizeL);
    margin-top: 3rem;
    line-height: 1.2;
  }
  p, blockquote {
    margin-top: 1.6rem;
  }
  h3 + p {
    margin-top: 1rem;
  }

  ${Grid} + p {
    margin-top: 2rem;
  }

  .gatsby-resp-image-wrapper {
    border-radius: 1rem;
    overflow: hidden;
    
  }

  ul {
    list-style-type: disc;
    padding-left: 2rem;
    margin-top: 2rem;
  }

  ${Grid} {
    margin-top: 2rem;
  }
  

  .vimeo {
    margin-top: 2rem;
  }
  video {
    margin-top: 1.6rem;
    border-radius: 1rem;
  }

  .mopa-grid {
    background: #f0f3f7;
    align-items: center;
    border-radius: 1rem;
    margin-top: 2rem;
    grid-column-gap: 3rem;

  

    h2, h3, .vimeo {
      margin-top: 0;
    }
   
    .text {
      padding: 4rem;
    }
    .player {
      margin: 0;
      padding: 1rem;
      iframe {
        border-radius: 4px;
      }
    }
  }
  * > :first-child {
      margin-top: 0;
  }
  a {
    /* font-weight: var(--medium); */
    color: var(--blue);
    text-decoration: underline;
    text-decoration-color: var(--gray);
    text-decoration-style: dotted;
    text-underline-offset: 4px;
    &:hover {
      text-decoration-color: var(--blue);
    }
  }
`

export const ProjectContent = ({post, shortcodes}) => {
    return (
    <StyledProjectContent background={post.frontmatter.background ? post.frontmatter.background : '#FFFFFF'}> 
        <Container>
        <FadeIn delay={0.25}>
        <MDXProvider components={shortcodes}>
        <MDXRenderer>{post.body}</MDXRenderer>
        </MDXProvider>
        </FadeIn>
        </Container>
    </StyledProjectContent>
    );
}
export default ProjectContent